import { SERVICE_BASE_URL } from "../../../../config/properties";
import httpClient, { HttpClient } from "../../../../core/api/HttpClient";

export interface FinalityLog {
  bankDetails: string;
  transactionDate: string;
  responseCode: string;
  responseDescription: null,
  officeServer: string;
  client: string;
  responseBody: string;
  requestTime: string;
}

export interface GetFinalityLogsRequest {
  page: number;
  pageSize: number;
  requestDate?: string;
  client?: string;
  transactionDate?: string;
  bankDetails?: string;
}

export interface GetFinalityLogsResponse {
  count: number;
  content: FinalityLog[];
}

interface FinalityRepository {
  getFinalityLogs: (request: GetFinalityLogsRequest) => Promise<GetFinalityLogsResponse>;
}

class FinalityRepositoryImpl implements FinalityRepository {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async getFinalityLogs(request: GetFinalityLogsRequest) {
    const response = await this.httpClient.post<GetFinalityLogsResponse>(
      `${SERVICE_BASE_URL}/api/v1/finality/logs`,
      request
    );

    return response.data;
  }
}

const finalityRepository = new FinalityRepositoryImpl(httpClient);

export default finalityRepository;



